var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasPermission === 1
        ? [
            _c(
              "div",
              { staticClass: "forms" },
              [
                _c("div", { staticClass: "text" }, [_vm._v("基础信息")]),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      rules: _vm.rules,
                      size: "small",
                      "label-width": "96px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "主账号使用状态", prop: "usingStatus" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("主账号"),
                                    _c("br"),
                                    _vm._v("使用状态"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3590643686
                        ),
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择",
                              disabled: !_vm.permission.edit,
                            },
                            model: {
                              value: _vm.form.usingStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "usingStatus", $$v)
                              },
                              expression: "form.usingStatus",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.property_paccount_ustatus,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "所属平台", prop: "platformKey" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("所属平台"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2260969140
                        ),
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择",
                              disabled: !_vm.permission.edit,
                              filterable: "",
                            },
                            model: {
                              value: _vm.form.platformKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "platformKey", $$v)
                              },
                              expression: "form.platformKey",
                            },
                          },
                          _vm._l(_vm.shops, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: index },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "是否有子账号", prop: "hasSubsidiary" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("是否"),
                                    _c("br"),
                                    _vm._v("有子账号"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          91354669
                        ),
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "el-input",
                            attrs: { disabled: !_vm.permission.edit },
                            on: { change: _vm.toggleHasSubAccount },
                            model: {
                              value: _vm.form.hasSubsidiary,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hasSubsidiary", $$v)
                              },
                              expression: "form.hasSubsidiary",
                            },
                          },
                          _vm._l(_vm.hasSubsidiaryList, function (item) {
                            return _c(
                              "el-radio",
                              {
                                key: item.dictId,
                                attrs: { label: item.dictId },
                              },
                              [_vm._v(_vm._s(item.dictName))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "登录网址", prop: "loginUrl" } },
                      [
                        _c(
                          "div",
                          { staticClass: "textarea-con" },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                clearable: "",
                                maxlength: "128",
                                type: "textarea",
                                rows: "3",
                                "show-word-limit": "",
                                disabled: !_vm.permission.edit,
                              },
                              model: {
                                value: _vm.form.loginUrl,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "loginUrl", $$v)
                                },
                                expression: "form.loginUrl",
                              },
                            }),
                            _vm.permission.copy
                              ? [
                                  _vm.form.loginUrl
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "btn-copy",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCopy(
                                                _vm.form.loginUrl
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("复")]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "btn-copy btn-copy-dis",
                                        },
                                        [_vm._v("复")]
                                      ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "注册形式", prop: "regType" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("注册形式"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          786032640
                        ),
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "el-input",
                            attrs: { disabled: !_vm.permission.edit },
                            model: {
                              value: _vm.form.regType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "regType", $$v)
                              },
                              expression: "form.regType",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.property_paccount_reg_type,
                            function (item) {
                              return _c(
                                "el-radio",
                                {
                                  key: item.dictId,
                                  attrs: { label: item.dictId },
                                },
                                [_vm._v(_vm._s(item.dictName))]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.regType == 1
                      ? [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "公司主体", prop: "companyName" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "50",
                                  type: "textarea",
                                  rows: "3",
                                  "show-word-limit": "",
                                  disabled: !_vm.permission.edit,
                                },
                                model: {
                                  value: _vm.form.companyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "companyName", $$v)
                                  },
                                  expression: "form.companyName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "label-star",
                              attrs: {
                                label: "法人/经营人",
                                prop: "legalPerson",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("法人/经"),
                                            _c("br"),
                                            _vm._v("营人"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                647092092
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "30",
                                  type: "textarea",
                                  rows: "3",
                                  "show-word-limit": "",
                                  disabled: !_vm.permission.edit,
                                },
                                model: {
                                  value: _vm.form.legalPerson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "legalPerson", $$v)
                                  },
                                  expression: "form.legalPerson",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "账号名称" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入",
                            clearable: "",
                            maxlength: "64",
                            type: "text",
                            "show-word-limit": "",
                            disabled: !_vm.permission.edit,
                          },
                          model: {
                            value: _vm.form.accountName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "accountName", $$v)
                            },
                            expression: "form.accountName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.form.showType == 1
                      ? [
                          _c("div", { staticClass: "line" }),
                          _c("div", { staticClass: "text" }, [
                            _vm._v("主账号"),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "登录账号",
                                prop: "mainAccount.account",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "textarea-con" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                      maxlength: "48",
                                      type: "textarea",
                                      rows: "3",
                                      "show-word-limit": "",
                                      disabled: !_vm.permission.edit,
                                    },
                                    model: {
                                      value: _vm.form.mainAccount.account,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.mainAccount,
                                          "account",
                                          $$v
                                        )
                                      },
                                      expression: "form.mainAccount.account",
                                    },
                                  }),
                                  _vm.permission.copy
                                    ? [
                                        _vm.form.mainAccount.account
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "btn-copy",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onCopy(
                                                      _vm.form.mainAccount
                                                        .account
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("复")]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-copy btn-copy-dis",
                                              },
                                              [_vm._v("复")]
                                            ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "账号密码",
                                prop: "mainAccount.password",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "textarea-con" },
                                [
                                  _vm.isDetail
                                    ? [
                                        _vm.form.mainAccount.passwordEye
                                          ? _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                clearable: "",
                                                maxlength: "48",
                                                type: "textarea",
                                                rows: "3",
                                                "show-word-limit": "",
                                                disabled: !_vm.permission.edit,
                                              },
                                              model: {
                                                value:
                                                  _vm.form.mainAccount.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form.mainAccount,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.mainAccount.password",
                                              },
                                            })
                                          : _c("el-input", {
                                              attrs: {
                                                value: "******",
                                                clearable: "",
                                                maxlength: "48",
                                                type: "textarea",
                                                rows: "3",
                                                readonly: "",
                                              },
                                            }),
                                      ]
                                    : _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入",
                                          clearable: "",
                                          maxlength: "48",
                                          type: "textarea",
                                          rows: "3",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.form.mainAccount.password,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.mainAccount,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.mainAccount.password",
                                        },
                                      }),
                                  _vm.permission.copy
                                    ? [
                                        _vm.form.mainAccount.password
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "btn-copy",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onCopy(
                                                      _vm.form.mainAccount
                                                        .password
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("复")]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-copy btn-copy-dis",
                                              },
                                              [_vm._v("复")]
                                            ),
                                      ]
                                    : _vm._e(),
                                  _vm.permission.password
                                    ? [
                                        _vm.form.mainAccount.passwordEye
                                          ? _c("div", {
                                              staticClass: "i-eye",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEye("main")
                                                },
                                              },
                                            })
                                          : _c("div", {
                                              staticClass: "i-eye-hide",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEye("main")
                                                },
                                              },
                                            }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "账号使用人",
                                prop: "mainAccount.usingUserList",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  key: "main",
                                  staticClass: "select-u",
                                  class: !_vm.permission.edit ? "disabled" : "",
                                  attrs: {
                                    "value-key": "name",
                                    placeholder: "选择账号使用人",
                                    "collapse-tags": "",
                                    size: "medium",
                                    multiple: "",
                                    "popper-class": "hidden",
                                    disabled: !_vm.permission.edit,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.openUserPicker(
                                        _vm.permission.edit,
                                        "main"
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.form.mainAccount.usingUserList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.mainAccount,
                                        "usingUserList",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.mainAccount.usingUserList",
                                  },
                                },
                                _vm._l(
                                  _vm.form.mainAccount.usingUserList,
                                  function (wc, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: wc.name, value: wc },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "clear-both" }),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "label-star",
                              attrs: {
                                label: "账号绑定手机号",
                                prop: "mainAccount.phone",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("账号绑定"),
                                            _c("br"),
                                            _vm._v("手机号"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1260160528
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "11",
                                  "show-word-limit": "",
                                  disabled: !_vm.permission.edit,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getOwnerName("main", "phone")
                                  },
                                },
                                model: {
                                  value: _vm.form.mainAccount.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.mainAccount, "phone", $$v)
                                  },
                                  expression: "form.mainAccount.phone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "绑定手机号所属员工" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("绑定手机号"),
                                            _c("br"),
                                            _vm._v("所属员工"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1965034146
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "自动识别",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.form.mainAccount.phoneOwner,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.mainAccount,
                                      "phoneOwner",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainAccount.phoneOwner",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "绑定微信号",
                                prop: "mainAccount.wechat",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [_vm._v("绑定微信号")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3672320090
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "20",
                                  "show-word-limit": "",
                                  disabled: !_vm.permission.edit,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getOwnerName("main", "wechat")
                                  },
                                },
                                model: {
                                  value: _vm.form.mainAccount.wechat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.mainAccount,
                                      "wechat",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainAccount.wechat",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "绑定微信号所属员工" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("绑定微信号"),
                                            _c("br"),
                                            _vm._v("所属员工"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2437815868
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "自动识别",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.form.mainAccount.wechatOwner,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.mainAccount,
                                      "wechatOwner",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainAccount.wechatOwner",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "绑定QQ号",
                                prop: "mainAccount.qq",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [_vm._v("绑定QQ号")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1967342229
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "12",
                                  "show-word-limit": "",
                                  disabled: !_vm.permission.edit,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getOwnerName("main", "qq")
                                  },
                                },
                                model: {
                                  value: _vm.form.mainAccount.qq,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.mainAccount, "qq", $$v)
                                  },
                                  expression: "form.mainAccount.qq",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "绑定QQ号所属员工" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("绑定QQ号"),
                                            _c("br"),
                                            _vm._v("所属员工"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                553766387
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "自动识别",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.form.mainAccount.qqOwner,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.mainAccount,
                                      "qqOwner",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainAccount.qqOwner",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "绑定邮箱",
                                prop: "mainAccount.email",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [_vm._v("绑定邮箱")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2337933405
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  clearable: "",
                                  maxlength: "256",
                                  disabled: !_vm.permission.edit,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getOwnerName("main", "email")
                                  },
                                },
                                model: {
                                  value: _vm.form.mainAccount.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.mainAccount, "email", $$v)
                                  },
                                  expression: "form.mainAccount.email",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "绑定邮箱所属员工" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("绑定邮箱"),
                                            _c("br"),
                                            _vm._v("所属员工"),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3940700731
                              ),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "自动识别",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.form.mainAccount.emailOwner,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.mainAccount,
                                      "emailOwner",
                                      $$v
                                    )
                                  },
                                  expression: "form.mainAccount.emailOwner",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "是否有ID",
                                    prop: "mainAccount.hasId",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [_vm._v("是否有ID")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3304105124
                                  ),
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "radio-group",
                                      on: { change: _vm.toggleMainHasId },
                                      model: {
                                        value: _vm.form.mainAccount.hasId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.mainAccount,
                                            "hasId",
                                            $$v
                                          )
                                        },
                                        expression: "form.mainAccount.hasId",
                                      },
                                    },
                                    _vm._l(_vm.hasIdList, function (item) {
                                      return _c(
                                        "el-radio",
                                        {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictId,
                                            disabled: !_vm.permission.edit,
                                          },
                                        },
                                        [_vm._v(_vm._s(item.dictName))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm.form.mainAccount.hasId == 1 &&
                                  _vm.permission.edit
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "add-button add-id",
                                          attrs: { type: "primary", plain: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addPlus(1)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-plus",
                                          }),
                                          _vm._v(" 新增ID "),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.mainAccount.hasId === 1
                            ? _vm._l(
                                _vm.form.mainAccount.accountIdList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { key: "main-id-" + index },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "账号ID(0*)" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "账号ID(" +
                                                            _vm._s(
                                                              _vm.makeIndex(
                                                                index
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                    index > 0 &&
                                                    _vm.permission.edit
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "del-button del-id",
                                                            attrs: {
                                                              type: "primary",
                                                              plain: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeId(
                                                                  index,
                                                                  1
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" 删除ID ")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "204px" },
                                            attrs: {
                                              placeholder: "请输入",
                                              clearable: "",
                                              maxlength: "48",
                                              type: "textarea",
                                              rows: "3",
                                              "show-word-limit": "",
                                              disabled: !_vm.permission.edit,
                                            },
                                            model: {
                                              value: item.accountId,
                                              callback: function ($$v) {
                                                _vm.$set(item, "accountId", $$v)
                                              },
                                              expression: "item.accountId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "所属五域类目",
                                            prop: "categoryId",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-label",
                                                      },
                                                      [
                                                        _vm._v("所属"),
                                                        _c("br"),
                                                        _vm._v("五域类目"),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("el-cascader", {
                                            attrs: {
                                              size: "mini",
                                              clearable: "",
                                              options: _vm.categoryIdList,
                                              props: {
                                                label: "categoryName",
                                                value: "id",
                                                emitPath: false,
                                              },
                                              filterable: "",
                                              disabled: !_vm.permission.edit,
                                            },
                                            model: {
                                              value: item.categoryId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "categoryId",
                                                  $$v
                                                )
                                              },
                                              expression: "item.categoryId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "渠道号" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入",
                                              clearable: "",
                                              maxlength: "32",
                                              "show-word-limit": "",
                                              disabled: !_vm.permission.edit,
                                            },
                                            model: {
                                              value: item.channelName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "channelName",
                                                  $$v
                                                )
                                              },
                                              expression: "item.channelName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "ID使用状态",
                                            prop: `mainAccount.accountIdList[${index}].status`,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-label",
                                                      },
                                                      [_vm._v("ID使用状态")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择",
                                                disabled: !_vm.permission.edit,
                                              },
                                              model: {
                                                value: item.status,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "status", $$v)
                                                },
                                                expression: "item.status",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dictionaries
                                                .Property_platform_id_status,
                                              function (items) {
                                                return _c("el-option", {
                                                  key: items.dictId,
                                                  attrs: {
                                                    label: items.dictName,
                                                    value: items.dictId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm.form.hasSubsidiary == 1
                      ? _c(
                          "div",
                          [
                            _vm._l(
                              _vm.form.subAccountList,
                              function (subAccountItem, index) {
                                return _c(
                                  "div",
                                  { key: "sub-account-" + index },
                                  [
                                    _c("div", { staticClass: "line" }),
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm._v(
                                          "子账号" +
                                            _vm._s(_vm.makeIndex(index))
                                        ),
                                        index > 0 && _vm.permission.edit
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass:
                                                  "del-button del-sub",
                                                attrs: {
                                                  type: "primary",
                                                  plain: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeId(
                                                      index,
                                                      4
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除子账号")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "登录账号",
                                          prop: `subAccountList[${index}].account`,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "textarea-con" },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "204px" },
                                              attrs: {
                                                placeholder: "请输入",
                                                clearable: "",
                                                maxlength: "48",
                                                type: "textarea",
                                                rows: "3",
                                                "show-word-limit": "",
                                                disabled: !_vm.permission.edit,
                                              },
                                              model: {
                                                value:
                                                  _vm.form.subAccountList[index]
                                                    .account,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form.subAccountList[
                                                      index
                                                    ],
                                                    "account",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.subAccountList[index].account",
                                              },
                                            }),
                                            _vm.permission.copy
                                              ? [
                                                  _vm.form.subAccountList[index]
                                                    .account
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-copy",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onCopy(
                                                                _vm.form
                                                                  .subAccountList[
                                                                  index
                                                                ].account
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("复")]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-copy btn-copy-dis",
                                                        },
                                                        [_vm._v("复")]
                                                      ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "账号密码" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "textarea-con" },
                                          [
                                            _vm.isDetail
                                              ? [
                                                  _vm.form.subAccountList[index]
                                                    .passwordEye
                                                    ? _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "48",
                                                          type: "textarea",
                                                          rows: "3",
                                                          "show-word-limit": "",
                                                          disabled:
                                                            !_vm.permission
                                                              .edit,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .subAccountList[
                                                              index
                                                            ].password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form
                                                                .subAccountList[
                                                                index
                                                              ],
                                                              "password",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.subAccountList[index].password",
                                                        },
                                                      })
                                                    : _vm.form.subAccountList[
                                                        index
                                                      ].id
                                                    ? _c("el-input", {
                                                        attrs: {
                                                          value: "******",
                                                          clearable: "",
                                                          maxlength: "48",
                                                          type: "textarea",
                                                          rows: "3",
                                                          readonly: "",
                                                        },
                                                      })
                                                    : _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "48",
                                                          type: "textarea",
                                                          rows: "3",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .subAccountList[
                                                              index
                                                            ].password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form
                                                                .subAccountList[
                                                                index
                                                              ],
                                                              "password",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.subAccountList[index].password",
                                                        },
                                                      }),
                                                ]
                                              : _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入",
                                                    clearable: "",
                                                    maxlength: "48",
                                                    type: "textarea",
                                                    rows: "3",
                                                    "show-word-limit": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.subAccountList[
                                                        index
                                                      ].password,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form.subAccountList[
                                                          index
                                                        ],
                                                        "password",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.subAccountList[index].password",
                                                  },
                                                }),
                                            _vm.permission.copy
                                              ? [
                                                  _vm.form.subAccountList[index]
                                                    .password
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-copy",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onCopy(
                                                                _vm.form
                                                                  .subAccountList[
                                                                  index
                                                                ].password
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("复")]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-copy btn-copy-dis",
                                                        },
                                                        [_vm._v("复")]
                                                      ),
                                                ]
                                              : _vm._e(),
                                            _vm.form.subAccountList[index].id &&
                                            _vm.permission.password
                                              ? [
                                                  _vm.form.subAccountList[index]
                                                    .passworddEye
                                                    ? _c("div", {
                                                        staticClass: "i-eye",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onEye(
                                                              "sub",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _c("div", {
                                                        staticClass:
                                                          "i-eye-hide",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onEye(
                                                              "sub",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "账号使用人",
                                          prop: `subAccountList[${index}].usingUserIdList`,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [_vm._v("账号使用人")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            key: "sub-" + index,
                                            staticClass: "select-u",
                                            class: !_vm.permission.edit
                                              ? "disabled"
                                              : "",
                                            attrs: {
                                              "value-key": "name",
                                              placeholder: "选择账号使用人",
                                              "collapse-tags": "",
                                              size: "medium",
                                              multiple: "",
                                              "popper-class": "hidden",
                                              disabled: !_vm.permission.edit,
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.openUserPicker(
                                                  _vm.permission.edit,
                                                  "sub",
                                                  index
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.form.subAccountList[index]
                                                  .usingUserList,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.subAccountList[
                                                    index
                                                  ],
                                                  "usingUserList",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.subAccountList[index].usingUserList",
                                            },
                                          },
                                          _vm._l(
                                            _vm.form.subAccountList[index]
                                              .usingUserList,
                                            function (wc, index) {
                                              return _c("el-option", {
                                                key: "sub-" + index,
                                                attrs: {
                                                  label: wc.name,
                                                  value: wc,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "clear-both" }),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "label-star",
                                        attrs: {
                                          label: "账号绑定手机号",
                                          prop: `subAccountList[${index}].phone`,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [
                                                      _vm._v("账号绑定"),
                                                      _c("br"),
                                                      _vm._v("手机号"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            clearable: "",
                                            maxlength: "11",
                                            "show-word-limit": "",
                                            disabled: !_vm.permission.edit,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getOwnerName(
                                                "sub",
                                                "phone",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .phone,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].phone",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "绑定手机号所属员工" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [
                                                      _vm._v("绑定手机号"),
                                                      _c("br"),
                                                      _vm._v("所属员工"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "自动识别",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .phoneOwner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "phoneOwner",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].phoneOwner",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "绑定微信号",
                                          prop: `subAccountList[${index}].wechat`,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [_vm._v("绑定微信号")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            clearable: "",
                                            maxlength: "20",
                                            "show-word-limit": "",
                                            disabled: !_vm.permission.edit,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getOwnerName(
                                                "sub",
                                                "wechat",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .wechat,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "wechat",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].wechat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "绑定微信号所属员工" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [
                                                      _vm._v("绑定微信号"),
                                                      _c("br"),
                                                      _vm._v("所属员工"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "自动识别",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .wechatOwner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "wechatOwner",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].wechatOwner",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "绑定QQ号",
                                          prop: `subAccountList[${index}].qq`,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [_vm._v("绑定QQ号")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            clearable: "",
                                            maxlength: "12",
                                            "show-word-limit": "",
                                            disabled: !_vm.permission.edit,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getOwnerName(
                                                "sub",
                                                "qq",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index].qq,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "qq",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].qq",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "绑定QQ号所属员工" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [
                                                      _vm._v("绑定QQ号"),
                                                      _c("br"),
                                                      _vm._v("所属员工"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "自动识别",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .qqOwner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "qqOwner",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].qqOwner",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "绑定邮箱",
                                          prop: `subAccountList[${index}].email`,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [_vm._v("绑定邮箱")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            clearable: "",
                                            maxlength: "256",
                                            disabled: !_vm.permission.edit,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getOwnerName(
                                                "sub",
                                                "email",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .email,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: { label: "绑定邮箱所属员工" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-label",
                                                    },
                                                    [
                                                      _vm._v("绑定邮箱"),
                                                      _c("br"),
                                                      _vm._v("所属员工"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "自动识别",
                                            disabled: "",
                                          },
                                          model: {
                                            value:
                                              _vm.form.subAccountList[index]
                                                .emailOwner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.subAccountList[index],
                                                "emailOwner",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.subAccountList[index].emailOwner",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "是否有ID",
                                              prop: `subAccountList[${index}].hasId`,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-label",
                                                        },
                                                        [_vm._v("是否有ID")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                staticClass: "radio-group",
                                                attrs: {
                                                  disabled:
                                                    !_vm.permission.edit,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.toggleSubHasId(
                                                      $event,
                                                      index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.subAccountList[
                                                      index
                                                    ].hasId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.subAccountList[
                                                        index
                                                      ],
                                                      "hasId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.subAccountList[index].hasId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.hasIdList,
                                                function (item) {
                                                  return _c(
                                                    "el-radio",
                                                    {
                                                      key: item.dictId,
                                                      attrs: {
                                                        label: item.dictId,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.dictName)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _vm.form.subAccountList[index]
                                              .hasId == 1 && _vm.permission.edit
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "add-button add-id",
                                                    attrs: {
                                                      type: "primary",
                                                      plain: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addPlus(
                                                          2,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-plus",
                                                    }),
                                                    _vm._v(" 新增ID "),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    subAccountItem.hasId === 1 &&
                                    subAccountItem.accountIdList.length > 0
                                      ? _vm._l(
                                          subAccountItem.accountIdList,
                                          function (item, idIndex) {
                                            return _c(
                                              "div",
                                              { key: "sub-id-" + idIndex },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "账号ID（01）",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "账号ID（" +
                                                                      _vm._s(
                                                                        _vm.makeIndex(
                                                                          idIndex
                                                                        )
                                                                      ) +
                                                                      "） "
                                                                  ),
                                                                ]
                                                              ),
                                                              idIndex > 0 &&
                                                              _vm.permission
                                                                .edit
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      staticClass:
                                                                        "del-button del-id",
                                                                      attrs: {
                                                                        type: "primary",
                                                                        plain:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeId(
                                                                              idIndex,
                                                                              2,
                                                                              index
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " 删除ID "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "204px",
                                                      },
                                                      attrs: {
                                                        placeholder: "请输入",
                                                        clearable: "",
                                                        maxlength: "40",
                                                        type: "textarea",
                                                        rows: "3",
                                                        "show-word-limit": "",
                                                        disabled:
                                                          !_vm.permission.edit,
                                                      },
                                                      model: {
                                                        value: item.accountId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "accountId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.accountId",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "所属五域类目",
                                                      prop: "categoryId",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "所属"
                                                                  ),
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    "五域类目"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("el-cascader", {
                                                      attrs: {
                                                        size: "mini",
                                                        clearable: "",
                                                        options:
                                                          _vm.categoryIdList,
                                                        props: {
                                                          label: "categoryName",
                                                          value: "id",
                                                          emitPath: false,
                                                        },
                                                        filterable: "",
                                                        disabled:
                                                          !_vm.permission.edit,
                                                      },
                                                      model: {
                                                        value: item.categoryId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "categoryId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.categoryId",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: { label: "渠道号" },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        width: "204px",
                                                      },
                                                      attrs: {
                                                        placeholder: "请输入",
                                                        clearable: "",
                                                        maxlength: "32",
                                                        type: "textarea",
                                                        rows: "3",
                                                        "show-word-limit": "",
                                                        disabled:
                                                          !_vm.permission.edit,
                                                      },
                                                      model: {
                                                        value: item.channelName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "channelName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.channelName",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "ID使用状态",
                                                      prop: `subAccountList[${index}].accountIdList[${idIndex}].status`,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "ID使用状态"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          disabled:
                                                            !_vm.permission
                                                              .edit,
                                                        },
                                                        model: {
                                                          value: item.status,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "status",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.status",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.dictionaries
                                                          .Property_platform_id_status,
                                                        function (items) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: items.dictId,
                                                              attrs: {
                                                                label:
                                                                  items.dictName,
                                                                value:
                                                                  items.dictId,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }
                            ),
                            _vm.permission.edit
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "add-button add-sub",
                                    attrs: { type: "primary", plain: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPlus(4)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _vm._v(" 新增子账号 "),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "line" }),
                    _c("div", { staticClass: "text" }, [_vm._v("其他信息")]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "是否有店铺", prop: "hasShop" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "custom-label" },
                                        [_vm._v("是否有店铺")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              429448068
                            ),
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "radio-group",
                                attrs: { disabled: !_vm.permission.edit },
                                on: { change: _vm.toggleHasShop },
                                model: {
                                  value: _vm.form.hasShop,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "hasShop", $$v)
                                  },
                                  expression: "form.hasShop",
                                },
                              },
                              _vm._l(_vm.hasShopList, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.dictId,
                                    attrs: { label: item.dictId },
                                  },
                                  [_vm._v(_vm._s(item.dictName))]
                                )
                              }),
                              1
                            ),
                            _vm.form.hasShop == 1 && _vm.permission.edit
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "add-button add-shop",
                                    attrs: { type: "primary", plain: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPlus(3)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _vm._v(" 新增店铺 "),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.hasShop == 1
                      ? _vm._l(_vm.form.shopList, function (item, index) {
                          return _c(
                            "div",
                            { key: "shop-" + index },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "店铺名称",
                                    prop: `shopList[${index}].shopName`,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [
                                                _vm._v(
                                                  "店铺" +
                                                    _vm._s(_vm.makeIndex(index))
                                                ),
                                                _c("br"),
                                                _vm._v("名称"),
                                              ]
                                            ),
                                            index > 0 && _vm.permission.edit
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "del-button del-shop",
                                                    attrs: {
                                                      type: "primary",
                                                      plain: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeId(
                                                          index,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 删除店铺 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "204px" },
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                      maxlength: "48",
                                      type: "textarea",
                                      rows: "3",
                                      "show-word-limit": "",
                                      disabled: !_vm.permission.edit,
                                    },
                                    model: {
                                      value: item.shopName,
                                      callback: function ($$v) {
                                        _vm.$set(item, "shopName", $$v)
                                      },
                                      expression: "item.shopName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "店铺ID",
                                    prop: `shopList[${index}].shopId`,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [
                                                _vm._v(
                                                  "店铺" +
                                                    _vm._s(
                                                      _vm.makeIndex(index)
                                                    ) +
                                                    "ID"
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "204px" },
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                      maxlength: "48",
                                      type: "textarea",
                                      rows: "3",
                                      "show-word-limit": "",
                                      disabled: !_vm.permission.edit,
                                    },
                                    model: {
                                      value: item.shopId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "shopId", $$v)
                                      },
                                      expression: "item.shopId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "店铺状态",
                                    prop: `shopList[${index}].status`,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [
                                                _vm._v(
                                                  "店铺" +
                                                    _vm._s(_vm.makeIndex(index))
                                                ),
                                                _c("br"),
                                                _vm._v("状态"),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: !_vm.permission.edit,
                                      },
                                      model: {
                                        value: item.status,
                                        callback: function ($$v) {
                                          _vm.$set(item, "status", $$v)
                                        },
                                        expression: "item.status",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries
                                        .property_platform_shop_status,
                                      function (items) {
                                        return _c("el-option", {
                                          key: items.dictId,
                                          attrs: {
                                            label: items.dictName,
                                            value: items.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        })
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "平台账号备注" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("平台账号"),
                                    _c("br"),
                                    _vm._v("备注"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1471305617
                        ),
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入",
                            clearable: "",
                            maxlength: "64",
                            type: "textarea",
                            rows: "3",
                            "show-word-limit": "",
                            disabled: !_vm.permission.edit,
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm.isDetail
                  ? [
                      _c("div", { staticClass: "line" }),
                      _c("div", { staticClass: "text" }, [_vm._v("更多信息")]),
                      _c(
                        "el-form",
                        {
                          staticClass: "form-list",
                          attrs: {
                            inline: true,
                            size: "small",
                            "label-width": "96px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间：" } },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.form.createdTime || "-")),
                              ]),
                            ]
                          ),
                          _c("el-form-item", { attrs: { label: "创建人：" } }, [
                            _c("div", { staticClass: "con" }, [
                              _vm._v(_vm._s(_vm.form.createdByName || "-")),
                            ]),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "平台账号状态：" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("平台账号   "),
                                            _c("br"),
                                            _vm._v("状态："),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1397647699
                              ),
                            },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm.form.statusLabel
                                  ? _c(
                                      "span",
                                      {
                                        class:
                                          "icon-status icon-status-" +
                                          _vm.form.status,
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.form.statusLabel)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "最后归属人：" } },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.form.ownerUserName || "-")),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "更新时间：" } },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.form.updatedTime || "-")),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "最近更新人：" } },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.form.updatedByName || "-")),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "最后归属部门：" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "custom-label" },
                                          [
                                            _vm._v("最后   "),
                                            _c("br"),
                                            _vm._v("归属部门："),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                151213012
                              ),
                            },
                            [
                              _c("div", { staticClass: "con" }, [
                                _vm._v(_vm._s(_vm.form.ownerDeptName || "-")),
                              ]),
                            ]
                          ),
                          _vm.form.status == 3 && _vm.form.cancelReason
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "注销原因：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(_vm._s(_vm.form.cancelReason)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.permission.history
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "历史记录：" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn-look",
                                          attrs: {
                                            type: "primary",
                                            plain: "",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit("onHistory")
                                            },
                                          },
                                        },
                                        [_vm._v("查看")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c("org-picker", {
              ref: "orgPicker",
              attrs: { title: "账号使用人", multiple: true },
              on: { ok: _vm.selectedUser },
            }),
          ]
        : _vm.hasPermission === 0
        ? _c("div", { staticClass: "no-permission" }, [
            _c("div", { staticClass: "pic" }),
            _c("div", { staticClass: "word" }, [_vm._v("抱歉，您缺少权限")]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }